// if (window.innerWidth < 1200) {
//     // Function to remove all existing custom <div> elements
//     function removeCustomDiv() {
//         document.querySelectorAll('.custom-div').forEach(function(customDiv) {
//             customDiv.remove();
//         });
//     }

//     // Function to insert a new <div> element
//     function insertCustomDiv(anchor) {
//         const megaMenu = anchor.closest(".megamenu");
//         if (megaMenu) {
//             // Remove existing custom <div> elements
//             removeCustomDiv();
            
//             // Create a new <div> element
//             const newDiv = document.createElement('div');
//             newDiv.classList.add('custom-div');
            
//             // Clone the anchor and add an icon-arrow span
//             const newAnchor = anchor.cloneNode(true);
//             const iconArrow = document.createElement('span');
//             iconArrow.classList.add('icon-arrow');
            
//             newDiv.appendChild(iconArrow);
//             newDiv.appendChild(newAnchor);

//             // Insert the new <div> before the menu-box
//             const menuBox = megaMenu.querySelector('.menu-box');
//             if (menuBox) {
//                 menuBox.parentNode.insertBefore(newDiv, menuBox);
//             }

//             // Add click event listener to the new anchor
//             iconArrow.addEventListener("click", function (event) {
//                 event.preventDefault();
//                 // Toggle the 'open-menu' class on the mega menu
//                 megaMenu.classList.toggle("open-menu");
//                 // Remove the newly added custom <div> elements
//                 removeCustomDiv();
//             });
//         }
//     }

//     // Open mega menu on click
//     document.querySelectorAll(".nav-item.megamenu > .nav-link").forEach(function (anchor) {
//         anchor.addEventListener("click", function (event) {
//             event.preventDefault(); // Prevent the default anchor behavior
//             const megaMenu = anchor.closest(".megamenu");
//             if (megaMenu) {
//                 megaMenu.classList.toggle("open-menu");
//                 // Call the function to insert the new <div>
//                 insertCustomDiv(anchor);
//             }
//         });
//     });

//     // Close mega menu on click event of icon-arrow
//     document.querySelectorAll(".icon-arrow").forEach(function (icon) {
//         icon.addEventListener("click", function () {
//             const megaMenu = icon.closest(".megamenu");
//             if (megaMenu) {
//                 megaMenu.classList.toggle("open-menu");
//             }
//         });
//     });

//     // Click event handler for the hamburger icon
//     const hamburgerIcon = document.getElementById('site-header-menu-toggle');
//     const navItems = document.querySelectorAll('.nav-item');

//     // Add a click event listener to the hamburger icon
//     hamburgerIcon.addEventListener('click', function() {
//         // Loop through each nav item and remove the 'open-menu' class
//         navItems.forEach(function(navItem) {
//             navItem.classList.remove('open-menu');
//         });
//     });
// }

// Desktop: ensure only one mega menu is visible when hovering between items
if (window.innerWidth >= 1200) {
    const megamenus = document.querySelectorAll(".nav-item.megamenu");
    megamenus.forEach(function (megamenu) {
        megamenu.addEventListener("mouseenter", function () {
            // Close all other megamenus (remove focus so only this one shows via hover)
            megamenus.forEach(function (other) {
                if (other !== megamenu) {
                    other.classList.remove("focus", "megamenu-open");
                }
            });
            megamenu.classList.add("megamenu-open");
        });
        megamenu.addEventListener("mouseleave", function () {
            megamenu.classList.remove("megamenu-open");
        });
    });

    // Desktop click: close other megamenus when one is opened (e.g. keyboard/click)
    document.querySelectorAll(".nav-item.megamenu .nav-link").forEach(function (link) {
        link.addEventListener("click", function () {
            const current = this.closest(".megamenu");
            if (current) {
                megamenus.forEach(function (other) {
                    if (other !== current) {
                        other.classList.remove("focus", "megamenu-open");
                    }
                });
            }
        });
    });
}

if (window.innerWidth < 1200) {
    // Function to remove all existing custom <div> elements
    function removeCustomDiv() {
        document.querySelectorAll('.custom-div').forEach(function(customDiv) {
            customDiv.remove();
        });
    }

    // Function to insert a new <div> element
    function insertCustomDiv(anchor) {
        const megaMenu = anchor.closest(".megamenu");
        if (megaMenu) {
            // Remove existing custom <div> elements
            removeCustomDiv();
            
            // Create a new <div> element
            const newDiv = document.createElement('div');
            newDiv.classList.add('custom-div');
            
            // Clone the anchor and add an icon-arrow span
            const newAnchor = anchor.cloneNode(true);
            const iconArrow = document.createElement('span');
            iconArrow.classList.add('icon-arrow');
            
            newDiv.appendChild(iconArrow);
            newDiv.appendChild(newAnchor);

            // Insert the new <div> before the menu-box
            const menuBox = megaMenu.querySelector('.menu-box');
            if (menuBox) {
                menuBox.parentNode.insertBefore(newDiv, menuBox);
            }

            // Add click event listener to the new icon-arrow
            iconArrow.addEventListener("click", function (event) {
                event.preventDefault();
                // Toggle the 'open-menu' class on the mega menu
                megaMenu.classList.toggle("open-menu");
                // Remove the newly added custom <div> elements
                removeCustomDiv();
            });
        }
    }

    // Open mega menu on click of icon-wrapper; close other megamenus first
    const mobileMegamenus = document.querySelectorAll(".nav-item.megamenu");
    document.querySelectorAll(".megamenu .icon-wrapper").forEach(function (iconWrapper) {
        iconWrapper.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent the default behavior
            const megaMenu = iconWrapper.closest(".megamenu");
            if (megaMenu) {
                // Close all other megamenus before toggling this one
                mobileMegamenus.forEach(function (other) {
                    if (other !== megaMenu) {
                        other.classList.remove("open-menu");
                    }
                });
                megaMenu.classList.toggle("open-menu");
                // Call the function to insert the new <div>
                insertCustomDiv(iconWrapper.previousElementSibling); // Assuming the previous sibling is the anchor
            }
        });
    });

    // Close mega menu on click event of icon-arrow
    document.querySelectorAll(".icon-arrow").forEach(function (icon) {
        icon.addEventListener("click", function () {
            const megaMenu = icon.closest(".megamenu");
            if (megaMenu) {
                megaMenu.classList.toggle("open-menu");
            }
        });
    });

    // Click event handler for the hamburger icon
    const hamburgerIcon = document.getElementById('site-header-menu-toggle');
    const navItems = document.querySelectorAll('.nav-item');

    // Add a click event listener to the hamburger icon
    hamburgerIcon.addEventListener('click', function() {
        // Loop through each nav item and remove the 'open-menu' class
        navItems.forEach(function(navItem) {
            navItem.classList.remove('open-menu');
        });
    });
}
